window.app.directive("modalMenu", [
  function() {
    return {
      restrict: "A",
      scope: false,
      link: function(scope, element, attrs) {
        scope.$watch(attrs.modalMenu, function(menu) {
          scope.$watch(attrs.modalMenu + ".isOpen", function(isOpen) {
            if (isOpen) {
              element[0].parentElement.addEventListener("click", click, true);
            } else {
              element[0].parentElement.removeEventListener(
                "click",
                click,
                true
              );
            }
          });

          element.on("$destroy", function() {
            element.off();
            element[0].parentElement.removeEventListener("click", click, true);
          });

          function click(e) {
            if (e.srcEvent) {
              e = e.srcEvent;
            }
            if (element[0].contains(e.target)) {
              return;
            }

            e.stopPropagation();
            e.preventDefault();
            scope.$applyAsync(function() {
              menu.close();
            });
          }
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/modal-menu.js